import { IFiltersState, IResultsState, ITrackingData, ITrackingUserData, IUserGADataLayerData } from '../common/state';
import { ITrackingPageData } from '../serp/state/tracking';
import { ESortValue } from '../repositories/common/json_query';
import { getObjectTypeWithJsonQuery, getDealType } from './trackings';
import { dealTypeFromJsonQuery } from './category';
import { IBreadcrumb } from '../offer';

/**
 * Подготавливает данные трекинга для страницы
 */
export const prepareTrackingData = (
  filters: IFiltersState,
  results: IResultsState,
  breadcrumbs: IBreadcrumb[],
  userGAData: IUserGADataLayerData | null,
): ITrackingData => {
  let user: ITrackingUserData = {
    abGroup: 0,
    type: 'not_authorized',
  };

  if (userGAData) {
    user = {
      abGroup: userGAData.abGroup,
      type: userGAData.userType,
    };

    if (user.type !== 'not_authorized') {
      user.userId = userGAData.realtyUserId;
      user.cianUserId = userGAData.userId;
      user.email = userGAData.email;
    }
  }

  const { jsonQuery, totalOffers, queryString } = results;
  const { jsonQuery: jsonQueryFromFilters } = filters;

  const region = jsonQuery.region
    ? String(jsonQuery.region.value[0])
    : jsonQueryFromFilters && jsonQueryFromFilters.region
    ? String(jsonQueryFromFilters.region.value[0])
    : '1';

  const page: ITrackingPageData = {
    pageType: 'Listing',
    siteType: 'desktop',
    breadCrumbs: breadcrumbs ? breadcrumbs.map(b => b.title || '') : [],
    dealType: getDealType(dealTypeFromJsonQuery(jsonQuery)),
    objectType: getObjectTypeWithJsonQuery(jsonQuery),
    region,
    listingType: 'list',
    sortType: jsonQuery.sort ? jsonQuery.sort.value : ESortValue.Default,
    pageNumber: jsonQuery.page ? Number(jsonQuery.page.value) : 1,
    offersQty: totalOffers,
    queryString,
  } as ITrackingPageData;

  return {
    page,
    user,
  };
};
